import React, { Component } from 'react'
import Web3 from 'web3';
import ShopToken from '../Ticket1_0/ShopToken'
import ShopModulesPanel from '../ShopModulesPanel/ShopModulesPanel'
import BoxModules from '../BoxModules/BoxModules'
import SingleShopMenu from '../SingleShopMenu/SingleShopMenu'
import ShopMenu from '../ShopMenu/ShopMenu'
import ShopMeta from '../ShopMeta/ShopMeta'
import SingleUserBook from '../SingleUserBook/SingleUserBook'
import PriceList1_0 from '../Ticket1_0/PriceList1_0'
import FreebiesList1_0 from '../Freebies1_0/FreebiesList1_0'
import PairPriceList1_0 from '../PairSwapper1_0/PairPriceList1_0';
import ipfs from '../../ipfs'
import utils from '../../library'
import Base64Binary from '../../base64'
import html2canvas from 'html2canvas'
import FreeToken from '../Freebies1_0/FreeToken'
import ShopPair from '../PairSwapper1_0/ShopPair'

import './css.css';


class Ghost extends Component {
 constructor(){
     super()
     this.state={
         edit:true,
         items:[],
         box:"",
         boxindex:0,
         ticket:"",
         ticketindex:0,
         freebies:"",
         freebiesindex:0,
         swapper:"",
         swapperindex:0,
         mode:"default",
         amountItems:0,
         wallet:"",
         ismaster: false,
         sharing:false,
         sharingPage:"",
         shopName:"",
         shopDescription:"",
         ghostProducts:[]
        }
     this.setMode=this.setMode.bind(this)
     this.editMode=this.editMode.bind(this)
     this.setAmountItems=this.setAmountItems.bind(this)
 }



    componentDidMount(){
        this.setState({edit:false})
       // this.setWallet()
        this.loadGhosts()   
    
    }

    async loadGhosts(){
    
    utils.setGhostBackground(utils.getUrlVars()["dark"],utils.getUrlVars()["light"],utils.getUrlVars()["text"])
    let name=utils.getUrlVars()["name"]
    if(name!="")document.getElementById("ghostShop_name").innerHTML=name
    let description=utils.getUrlVars()["description"]
    if(description!="")document.getElementById("ghostShop_description").innerHTML=description
        let final=[]
        let s=utils.getUrlVars()["ghost"]
        s=utils.fromHex(s)
        s=s.substring(0,s.lastIndexOf("xxx"))
        //let reload=() => this.reload()
        let arr=s.split(",")
        let prp=this.props
        let stt=this.state
        await window.ethereum.enable().then(async function (accounts) { 
         
        for(let i=0;i<arr.length;i++){
          
          if(arr[i]!=""){
            
            let ticket=arr[i].substr(0,arr[i].lastIndexOf("x"))
            let prices=await utils.prices(ticket)
            let index=arr[i].substr(arr[i].lastIndexOf("x")+1,42)
            let code =await utils.ticketCode(ticket)
            let token=await utils.priceIndex(prices,index)
            let price =await utils.price(prices,token)
            let db=await utils.ticket2Box(ticket)
            if(code==4)final.push(<ShopToken ghost={false}  db={prp.db} priceList={prices} address={token} price={price} index={ticket+"x"+index} ticket={ticket} key={i} edit={""} name={"nnn"}></ShopToken>);
            if(code==7)final.push(<FreeToken ghost={false}  db={prp.db} priceList={prices} address={token} price={price} index={ticket+"x"+index} ticket={ticket} key={i} edit={""} name={"nnn"}></FreeToken>);
            if(code==9)final.push(<ShopPair ghost={false}   db={prp.db} priceList={prices} address={token} price={price} index={ticket+"x"+index} ticket={ticket} key={i} edit={""} name={"nnn"}></ShopPair>);

            //final.push(<GhostContainer ticketCode={code} db={prp.db} priceList={prices} address={token} price={price} index={ticket+"x"+index} ticket={ticket} key={i} edit={""} name={"nnn"}></GhostContainer>)
            }}
      
      })
      this.setState({ghostProducts:final})
    }


    async generateSharePage(time){
        this.setState({sharing:true})
        this.savePage(time)
          }

    async savePage(time){
        try{
            if(time>60)
            document.getElementById("twitter_sharing_info_panel").innerHTML="ipfs problems? better try later..."
            if(time==60)
            document.getElementById("twitter_sharing_info_panel").innerHTML="Please wait while propagating twitter card on ipfs..."
        }catch(e){}
        

            let myImage = new Image(600, 330);
        let shopNam=this.state.shopName
        let shopDescriptio=this.state.shopDescription    
        let image_0="/smartshop/ethereum400.png"
        let module="👻 GhostShop"
        let icon="👻"

            myImage.onload = async function(){
                console.log("image loaded")   
                let myETHImage = new Image(200, 200);
                myETHImage.onload = async function(){
                    const card = document.createElement('div');
                    card.className="card light lightblue text white"
                    const cardIcon = document.createElement('div');
                    cardIcon.className="left"
                    cardIcon.style.marginLeft="20px"
                    cardIcon.innerHTML=icon
                    card.appendChild(cardIcon)
                    const cardShopName = document.createElement('div');
                    cardShopName.className="right"
                    cardShopName.style.marginRight="20px"
                    cardShopName.style.marginBottom="20px"
                    cardShopName.innerHTML=document.getElementById("Ghost_header_mainlabel").innerHTML
                    card.appendChild(cardShopName)

                    const cardFooter = document.createElement('div');
                    cardFooter.className="center"
                    cardFooter.style.width="200"
                    cardFooter.innerHTML="🌈SmartShop"
                    cardFooter.style.marginBottom="20px"
                    

                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = myImage.width;
                    canvas.height = myImage.height;

                    ctx.fillStyle = "red";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    ctx.drawImage(myImage,0,0,600,330)
                    ctx.drawImage(myETHImage,400,70,150,150)
                    ctx.fillStyle = "#0788ae";
                    ctx.font = "30px Arial";           
                    ctx.fillText(module, 65, 85);
                    ctx.fillStyle = "white";
                    ctx.font = "30px Arial";
                    let amount=utils.getUrlVars()["ghost"].split(",").length
                    ctx.fillText("🏺 "+ amount+" items", 65, 180);
                    ctx.fillStyle = "#0788ae";
                    ctx.font = "35px Arial";
                    let tempName="Crypto Tokens Shop"
                    if(shopNam!="")tempName=shopNam
                    ctx.fillText(tempName, 70, 225);
                    ctx.fillStyle = utils.getRandomColor()
                    ctx.fillRect(canvas.width-2, canvas.height-2, 1, 1);
                    //document.getElementById("PriceList_finalContainer")
                    let widthc=(window.innerWidth-800)/2

                    let tempContainer=document.getElementById("PriceList_finalContainer")
                  
                    card.appendChild(tempContainer)
                    card.appendChild(cardFooter)
                    document.body.appendChild(card)
                    tempContainer.style.padding="20px"
                    html2canvas(card,
                        {
                        allowTaint:true,
                        scale:1,
                        x:0,
                        y:document.documentElement.scrollTop || document.body.scrollTop
                        
                    }).then(function(canvasC) {
                        document.getElementById("MainShop_cardlist_container").appendChild(canvasC);
                        canvasC.style.width="600px"
                        document.getElementById("MainShop_cardlist_container").style.height=(canvasC.height/100*75)+"px"
                        canvasC.style.height=(canvasC.height/100*75)+"px"
                    });
                    
                    document.getElementById("PriceList_container_box").appendChild(tempContainer)
                    tempContainer.style.padding="0px"
                    document.getElementById("MainShop_card_container").appendChild(canvas)
                    card.remove();
                    let baseSixtyFour=canvas.toDataURL().replace(/data:image\/png;base64,/,'');
                    let byteArray = Base64Binary.decodeArrayBuffer(baseSixtyFour);  
                    var enc = new TextEncoder(); // always utf-8
                    const buffer0 = await Buffer.from(byteArray);
                    console.log("IPFS0");
                    await ipfs.add(buffer0).then(async (response) => {
                        
                        let image="https://ipfs.io/ipfs/"+response["path"].toString()
                        let tempPage='<html lang="en"><head><title>SmartShop Twitter Share</title><meta name="viewport" content="width=device-width, initial-scale=1" /><meta name="twitter:card" content="summary_large_image"><meta name="twitter:site" content="@maxxflyer"><meta name="twitter:creator" content="@maxxflyer"><meta name="twitter:title" content="'+shopNam+'"><meta name="twitter:description" content="'+shopDescriptio+'"><meta name="twitter:image" content="'+image+'"><meta name="theme-color" content="#000000" /><meta name="description" content="'+shopDescriptio+'"></head><body style="background:#0788ae;"><div>ABC'+Math.random()+'</div><script>window.location.href = "http://localhost:50717/smartshop/?shop='+utils.getUrlVars()["shop"]+'";</script></body></html>'
                        
                        const buffer = await Buffer.from(tempPage);
                        console.log("IPFS1");
                        ipfs.add(buffer).then(async (response2) => { 
                            utils.countAndOpen('https://twitter.com/intent/tweet?url=https%3A%2F%2Fipfs.io%2Fipfs%2F'+response2["path"].toString(),time,"twitter_sharing_info_panel","Please wait while propagating twitter card on ipfs ...")
                        }).catch((err) => {       
                            console.error(err)   
                        })
                    }).catch((err) => {       
                        console.error(err)   
                    })
                };
                myETHImage.src = image_0
            };        
            myImage.src = '/smartshop/smartshop_twitter_base.jpg'
    }

    async setWallet(){
       
            let t=utils.getUrlVars()["code"]
            try{document.getElementById("Shop_social").innerHTML=utils.getAvatar(t)}catch(e){}  
            this.setState({wallet:t})
            this.render()          
        
    }

    async avatar(){
        window.history.pushState('avatar_page', 'AVATAR PAGE', '/happyfarm?account='+this.state.wallet)
        this.props.update("EmptyAvatar")
    }



    async setAmountItems(i){
        try{document.getElementById("Shop_amount").innerHTML="Items: "+i+" 🏺"}catch(e){}
        this.setState({amountItems:i})
    }


    editMode(){
        (!this.state.edit)?this.setState({edit:true}):this.setState({edit:false})
    }

    setMode(md){
        this.setState({mode:md})
        console.log("MODE",md)
    }

    async loadHeader(){
            let addr=""
            let shopNam=""
            let shopDescriptio=""
            await window.ethereum.enable().then(async function (accounts) {
                let metafound=false
                let mtdt
                if(utils.getUrlVars()["shop"]){
                    addr=utils.getUrlVars()["shop"]
                    mtdt = await utils.metadata(addr,accounts[0])
                    if(mtdt.length>=0)metafound=true
                }
                if((!utils.getUrlVars()["shop"])||(!metafound)){
                    addr=accounts[0]
                    mtdt=await utils.metadata(addr,addr)
                }
                document.getElementById("Shop_twitter_pan").style.display='none'
                document.getElementById("Shop_discord_pan").style.display='none'       
                if(mtdt.length>0){
                    console.log("MTDT",mtdt)
                    await fetch(utils.formatURL(mtdt)).then(response => response.json()).then(
                    response => {
                        console.log(JSON.stringify(response))
                        shopNam=response[0]["name"]  
                        shopDescriptio=response[0]["description"]
                        document.getElementById("Ghost_header_mainlabel").textContent=shopNam
                        document.getElementById("Shop_header_description").textContent=shopDescriptio
                        let back=response[0]["image"]
                        if(back=="")back='https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/27592dd5-bdf2-4e90-9e17-852077de3dd0/d2aytcz-fd1a408a-541d-465d-9f8d-9c662b5ba6db.jpg/v1/fill/w_900,h_600,q_75,strp/fading_blue_grunge_by_dyingbeautystock.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwic3ViIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl0sIm9iaiI6W1t7InBhdGgiOiIvZi8yNzU5MmRkNS1iZGYyLTRlOTAtOWUxNy04NTIwNzdkZTNkZDAvZDJheXRjei1mZDFhNDA4YS01NDFkLTQ2NWQtOWY4ZC05YzY2MmI1YmE2ZGIuanBnIiwid2lkdGgiOiI8PTkwMCIsImhlaWdodCI6Ijw9NjAwIn1dXX0.JSbyhtv1aQd2O8AzG2x1UTZLfyNdtwGNtNSgzKCDFTE'
                        document.getElementById("Shop_header_image").style.backgroundImage='url('+back+')'           
                        if(response[0]["twitter"].length>0){
                            document.getElementById("Shop_twitter_pan").addEventListener("click", () => utils.jumpsocial("https://twitter.com/"+response[0]["twitter"].replace(/[^\w\s]/gi, '')))
                            document.getElementById("Shop_twitter_pan").style.display='visible'                     
                        }
                        if(response[0]["discord"].length>0){
                            document.getElementById("Shop_discord_pan").addEventListener("click",  () => utils.jumpsocial("https://discord.gg/"+response[0]["discord"].replace(/[^\w\s]/gi, '')))
                            document.getElementById("Shop_discord_pan").style.display='visible'
                        }       
                    })
                }
            })
            await this.setState({shopName:shopNam,shopDescription:shopDescriptio})                   
        }

        setCookie(cname, cvalue,id) {
            let s=this.getCookie(cname)
            let arr=s.split(",")
            let arr2=[]
            let t=false
            for(let i=0;i<arr.length;i++){               
                if(arr[i]==cvalue+"_"+id){
                    t=true 
                    document.getElementById("Shop_settings_favoriteShop").style.opacity=0.3              
                }else{
                    arr2.push(arr[i])
                    document.getElementById("Shop_settings_favoriteShop").style.opacity=1
                }
            } 
            if(!t){
                arr2.push(cvalue+"_"+id)   
            }
            document.cookie = cname + "=" + arr2.toString() + "; path=/"        
        }
        
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          }
    

    render(){
        let s=this.getCookie("favoriteShop")
        let arr=s.split(",")
        let favoriteShop=false
        for(let i=0;i<arr.length;i++){
            if(arr[i]==utils.getUrlVars()["shop"]+"_0")
            favoriteShop=true 
        }

const final = [];
let n=0;

    console.log("RENDERING SHOP")
return(
        <div id="Shop_panel">
            <div id="Ghost_header" className="dark darkblue">
                <div id="Ghost_header_subpanel" className="light lightblue">
                    <div id="Shop_header_image">
                        <div id="Ghost_header_mainlabel" className="rainbow"><span id="ghostShop_name" aria-labelledby="jsx-a11y/accessible-emoji" role="img" onClick={() => utils.jump()}>👻 GhostShop</span> </div>   
                    </div>
                    <div id="ghostShop_description" className="dark darkblue text white"></div>
                </div>
            </div>
            <div id="PriceList_container_box">
                <div id="PriceList_finalContainer" className="ghostShop_PriceList_finalContainer">
                    {this.state.ghostProducts}
                </div>
                </div>
                {(this.state.ghostProducts.length>0)?
                        <div id="ghostShop_footer">
                        {(!this.state.sharing)?
                            <div title="Tweet" onClick={() => this.generateSharePage(60) }><img alt="Tweet" className="socialShare" src="https://i.imgur.com/cHP6bia.png" /></div>
                        :
                            <>
                                <div id="twitter_sharing_info_panel" className="twitter_sharing_info_panel">Please wait while propagating twitter card on ipfs...</div>
                                <input id="count_done" type="button" value="🤹 TRY AGAIN!" onClick={() => this.generateSharePage(120) }></input>
                                <div id="" className="MainShop_twitter_card_panel dark darkblue text white">
                                    or download card and post manually..
                                    <div id="MainShop_card_container" className="MainShop_card_container">
                                    </div> 
                                    <div id="MainShop_tag_panel">
                                        <div id="MainShop_tag_panel_left">🏷️</div>
                                        <div id="MainShop_tag_panel_left_tag" onClick={() => window.open("https://twitter.com/hashtag/smartshop")}>#smartshop</div>
                                        <div id="MainShop_tag_panel_right"><img className="MainShop_twitter_direct" onClick={() => window.open("https://twitter.com")} src="https://i.imgur.com/cHP6bia.png"></img></div>
                                        <div className="clear"></div>
                                    </div>
                                    <div id="MainShop_cardlist_container" className="MainShop_cardlist_container">
                                    </div> 
                                </div>
                                <div className="clear"/>   
                            </>
                        }
                        </div>
                    :<></>
                    }
            </div>
     
);
    }


}


const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default Ghost